<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M6 5.14284C6 3.72268 7.15127 2.57141 8.57143 2.57141H15.4286C16.8488 2.57141 18 3.72268 18 5.14284V18.8571C18 20.2773 16.8488 21.4286 15.4286 21.4286H8.57143C7.15127 21.4286 6 20.2773 6 18.8571V5.14284ZM10.2857 17.1428C9.81233 17.1428 9.42857 17.5266 9.42857 18C9.42857 18.4734 9.81233 18.8571 10.2857 18.8571H13.7143C14.1877 18.8571 14.5714 18.4734 14.5714 18C14.5714 17.5266 14.1877 17.1428 13.7143 17.1428H10.2857Z"
    />
  </svg>
</template>
